'use strict';

angular.module('msCore').service('wellnessSvc', ['httpSvc', '$q', '$sessionStorage', function (httpSvc, $q, $sessionStorage) {
  var answers = {};
  var assessments = [];
  var translatePrefix = 'onboarding';

  return {
    getAssessments: getAssessments,
    saveAssessmentResponses: saveAssessmentResponses,
    getAssessmentResponse: getAssessmentResponse,
    getAssessmentResponses: getAssessmentResponses,
    getAssessmentResponsesNested: getAssessmentResponsesNested,
    getAssessmentAnswer: getAssessmentAnswer,
    addAssessmentAnswer: addAssessmentAnswer,
    determineUserAssessmentStatus: determineUserAssessmentStatus,
    getTotalAnsweredCount: getTotalAnsweredCount,
    getWellnessCategory: getWellnessCategory,
    translatePrefix: translatePrefix
  };

  function getAssessments(types) {
    // reuse existing loaded assessments for duration of the session if possible
    if (assessments && assessments[1]) {
      return $q.when(assessments);
    }

    if (!types) {
      types = ['WELLNESS_ASSESSMENT', 'QUESTIONNAIRE'];
    }

    if (_.isArray(types) && types.includes("WELLNESS_ASSESSMENT") && types.includes("QUESTIONNAIRE")) {
      types = types[0] + '&types=' + types[1];
    }

    return httpSvc.get('/apiproxy/user/assessments?types=' + types).then(function (res) {
      assessments = res;
      return res;
    });
  }

  function getWellnessCategory() {
    if ($sessionStorage.user) {
      return $sessionStorage.user.wellnessCategory;
    }
    return '';
  }

  function getTotalAnsweredCount() {
    var count = 0,
        assessment;
    for (assessment in answers) {
      if (answers.hasOwnProperty(assessment)) {
        count += getAssessmentAnsweredCount(assessment);
      }
    }
    return count;
  }

  function determineUserAssessmentStatus(assessmentRequirement) {
    // find the first assessment that should be displayed to user
    var assessmentToTake = null;
    if (assessmentRequirement && assessmentRequirement.data) {
      _.each(assessmentRequirement.data, function (assessment, position) {
        _.each(assessment, function (req) {
          if (!assessmentToTake && req !== 'NO_ASSESSMENT_REQUIRED') {
            assessmentToTake = { position: position, requirement: req };
          }
        });
      });
    }
    return assessmentToTake;
  }

  function getAssessmentAnsweredCount(shortName) {
    var count = 0,
        key;
    for (key in answers[shortName]) {
      if (answers[shortName].hasOwnProperty(key)) {
        count++;
      }
    }
    return count;
  }

  function getAssessmentAnswer(assessment, question) {
    if (!answers[assessment.shortName]) {
      return undefined;
    }
    return answers[assessment.shortName][question];
  }

  function addAssessmentAnswer(assessment, question, answer) {
    if (!answers[assessment.shortName]) {
      answers[assessment.shortName] = {};
    }
    answers[assessment.shortName][question] = answer;
    if (getAssessmentAnsweredCount(assessment.shortName) === assessment.questions.length) {
      return true;
    }
    //enforce the WPAI rule for bailing out here
    if (assessment.shortName.toLowerCase() === 'wpai') {
      //find the wpai dropdown question and bail if they didn't anwer employed or part_time
      var questionSpec = assessment.questions.filter(function (aQuestion) {
        return aQuestion.id === question;
      })[0];
      if (questionSpec && questionSpec.questionType.toLowerCase() === 'drop_down') {
        return !(answer.toLowerCase() === 'employed' || answer.toLowerCase() === 'part_time');
      }
    }
    return false;
  }

  function saveAssessmentResponses(assessments) {
    var counter = 0,
        responses = [],
        assessment;
    while (assessments[counter]) {
      // not all assessments are required, don't submit unless there are answers
      assessment = assessments[counter];
      if (answers[assessment.shortName]) {
        responses.push({
          wellnessAssessmentShortName: assessment.shortName,
          answers: answers[assessment.shortName],
          questions: assessment.questions,
          questionCategories: assessment.categories
        });
      }
      counter++;
    }
    return httpSvc.post('/apiproxy/user/assessments/responses', responses);
  }

  function getAssessmentResponses() {
    var url = '/apiproxy/user/assessments/responses';
    return httpSvc.get(url).then(function (responses) {
      responses.forEach(function (response) {
        response.completedOn.datetime = response.completedOn.datetime + 'Z';
      });
      return responses;
    });
  }

  function getAssessmentResponsesNested() {
    var url = '/apiproxy/user/assessments/responses/nested_view';
    return httpSvc.get(url).then(function (responses) {
      responses.forEach(function (response) {
        response.completedOn.datetime = response.completedOn.datetime + 'Z';
      });
      return responses;
    });
  }

  function getAssessmentResponse(name) {
    var url = '/apiproxy/user/assessments/response/' + name;
    return httpSvc.get(url);
  }
}]);